import { ButtonLink } from "@/components/Buttons";
import QuestionnaireForm from "@/components/Form/QuestionnaireForm";
import ProcessInformation from "@/components/ProcessInformation";
import { useFormQuestionsQuery, useModal, useNotification } from "@/hooks";
import config from "@/lib/config";
import { COURSE_TRIAL_DURATION_UNIT, PAYMENT_METHOD_NAMES } from "@/lib/constants";
import dayjs from "@/lib/day";
import formatPrice from "@/lib/formatPrice";
import routes from "@/lib/routes";
import styles from "@/styles/Payment.module.scss";
import processStyles from "@/styles/Process.module.scss";
import Link from "next/link";
import { useEffect, useMemo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function SubscriptionFormStep3(_ref) {
  var _subscribeData$subscr, _subscribeData$subscr2, _course$channel;
  let {
    subscriptionData,
    paymentMethod,
    subscribeData,
    isSignUp
  } = _ref;
  const {
    course,
    subscriptionStatus /*broadcastDiscount*/
  } = subscriptionData;
  const price = formatPrice((course === null || course === void 0 ? void 0 : course.price) || 0);
  const trialFlag = subscriptionStatus.is_trial_enabled;
  // const broadcastDiscountFlag = useMemo(() => {
  //   // コースに適用されたキャンペーンのbroadcastDiscountフラグを参照して判定する
  //   const isBroadcastCampaign =
  //     course?.active_pricing?.campaign?.broadcastDiscount;
  //   return isBroadcastCampaign && broadcastDiscount?.result;
  // }, [course, broadcastDiscount]);
  // const broadcastDiscountPrice = formatPrice(course?.discount_price);
  // 契約API（subscription/subscribe）のsubscribeレスポンスのコースから価格取得
  let priceFromSubscribeData = subscribeData === null || subscribeData === void 0 || (_subscribeData$subscr = subscribeData.subscribe) === null || _subscribeData$subscr === void 0 || (_subscribeData$subscr = _subscribeData$subscr.course) === null || _subscribeData$subscr === void 0 || (_subscribeData$subscr = _subscribeData$subscr.active_pricing) === null || _subscribeData$subscr === void 0 ? void 0 : _subscribeData$subscr.payment_amount;
  let priceFromSubscribeOrder = subscribeData === null || subscribeData === void 0 || (_subscribeData$subscr2 = subscribeData.subscribe) === null || _subscribeData$subscr2 === void 0 ? void 0 : _subscribeData$subscr2.orderPrice;
  if (isNaN(parseInt(priceFromSubscribeData))) {
    // 価格が不正な場合は空文字を表示する
    priceFromSubscribeData = "";
  }
  if (isNaN(parseInt(priceFromSubscribeOrder))) {
    // 価格が不正な場合は空文字を表示する
    priceFromSubscribeOrder = "";
  }
  const {
    initialTransactionAt,
    trialStartAt,
    trialEndAt
  } = subscribeData === null || subscribeData === void 0 ? void 0 : subscribeData.subscribe;
  const trialTerm = useMemo(() => {
    if (trialFlag) {
      const s = dayjs(new Date(trialStartAt));
      const e = dayjs(new Date(trialEndAt));
      const {
        label,
        unit
      } = COURSE_TRIAL_DURATION_UNIT[course.trial_term_unit];
      return `${e.diff(s, unit)}${label}`;
    }
  }, [trialFlag, trialStartAt, trialEndAt]);
  const trialTermText = useMemo(() => {
    if (trialTerm) {
      return course !== null && course !== void 0 && course.trialCampaignFlag ? `${trialTerm}無料キャンペーン` : `${trialTerm}無料トライアル`;
    }
  }, [course, trialTerm]);

  // アンケート表示
  const questionId = config.signUpQuestionnaireId;
  const {
    showModal,
    hideModal
  } = useModal();
  const {
    showNotification
  } = useNotification();
  const {
    data: questionnaireData
  } = useFormQuestionsQuery({
    variables: {
      id: questionId
    }
  });

  //モーダル表示部分
  useEffect(() => {
    var _questionnaireData$fo;
    if (isSignUp && questionnaireData !== null && questionnaireData !== void 0 && (_questionnaireData$fo = questionnaireData.formQuestions) !== null && _questionnaireData$fo !== void 0 && _questionnaireData$fo.data) {
      var _questionnaireData$fo2;
      // true:スキップさせる
      // false:スキップさせない
      let isSkipAble = (_questionnaireData$fo2 = questionnaireData.formQuestions.values) === null || _questionnaireData$fo2 === void 0 ? void 0 : _questionnaireData$fo2.skipable;
      if (typeof isSkipAble !== "boolean") {
        isSkipAble = true;
      }
      showModal( /*#__PURE__*/_jsx(QuestionnaireForm, {
        hideModal: hideModal,
        showNotification: showNotification,
        questionId: questionId,
        isSkipAble: isSkipAble
      }), {
        style: "questionaireModal",
        closeButton: isSkipAble,
        outerAreaClose: isSkipAble
      });
    }
  }, [showModal, hideModal, questionId, questionnaireData, isSignUp]);
  return /*#__PURE__*/_jsxs(ProcessInformation, {
    complete: true,
    header: "\u8CFC\u5165\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F",
    children: [trialFlag && /*#__PURE__*/_jsxs("div", {
      children: [trialTerm, "\u306E\u7121\u6599", course.trialCampaignFlag && "キャンペーン", "\u671F\u9593\u3092\u304A\u697D\u3057\u307F\u304F\u3060\u3055\u3044"]
    }), /*#__PURE__*/_jsx("div", {
      className: `${styles.container} ${styles.center}`,
      children: /*#__PURE__*/_jsxs("div", {
        className: `${styles.section} ${styles.nopadding}`,
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.sectionLeft,
          children: /*#__PURE__*/_jsx("img", {
            src: course.thumbnailUrl
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.sectionRight,
          children: [/*#__PURE__*/_jsx("h4", {
            className: styles.title,
            children: course.name
          }), !trialFlag /*&& !broadcastDiscountFlag*/ && /*#__PURE__*/_jsxs("div", {
            className: `${styles.info} ${styles.price}`,
            children: [/*#__PURE__*/_jsx("div", {
              className: styles.left,
              children: "\u91D1\u984D"
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.right,
              children: [/*#__PURE__*/_jsxs("span", {
                className: styles.priceAmount,
                children: [priceFromSubscribeOrder, "\u5186"]
              }), "\uFF08\u7A0E\u8FBC\uFF09\uFF0F\u6708"]
            })]
          }), trialFlag /*&& !broadcastDiscountFlag*/ && /*#__PURE__*/_jsx("div", {
            className: `${styles.info} ${styles.price} ${styles.trialPrice}`,
            children: /*#__PURE__*/_jsxs("div", {
              className: styles.right,
              children: [/*#__PURE__*/_jsxs("div", {
                className: styles.labelArea,
                children: [/*#__PURE__*/_jsx("span", {
                  className: styles.bold,
                  children: trialTermText
                }), /*#__PURE__*/_jsx("span", {
                  className: styles.period,
                  children: `${trialEndAt}まで`
                })]
              }), /*#__PURE__*/_jsx("div", {
                className: styles.precautions,
                children: `※${course.trialText}終了時に月額${priceFromSubscribeData}円（税込）`
              })]
            })
          }), /*#__PURE__*/_jsxs("div", {
            className: `${styles.info} ${styles.paymentMethod}`,
            children: [/*#__PURE__*/_jsx("div", {
              className: styles.left,
              children: "\u652F\u6255\u65B9\u6CD5"
            }), /*#__PURE__*/_jsx("div", {
              className: styles.right,
              children: PAYMENT_METHOD_NAMES[paymentMethod]
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: styles.info,
            children: [/*#__PURE__*/_jsx("div", {
              className: styles.left,
              children: "\u521D\u56DE\u6C7A\u6E08\u65E5"
            }), /*#__PURE__*/_jsx("div", {
              className: styles.right,
              children: initialTransactionAt
            })]
          })]
        })]
      })
    }), /*#__PURE__*/_jsx("div", {
      className: styles.attentionNote,
      children: /*#__PURE__*/_jsxs("p", {
        children: ["\u5F15\u304D\u7D9A\u304DSPOOX\u3092\u304A\u697D\u3057\u307F\u304F\u3060\u3055\u3044", /*#__PURE__*/_jsx("br", {}), "\u672C\u5546\u54C1\u306F\u81EA\u52D5\u66F4\u65B0\u3068\u306A\u308A\u307E\u3059\u3002\u3054\u89E3\u7D04\u306E\u969B\u306F\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u3054\u5229\u7528\u72B6\u6CC1\u304B\u3089\u304A\u624B\u7D9A\u304D\u304F\u3060\u3055\u3044"]
      })
    }), /*#__PURE__*/_jsx("div", {
      className: processStyles.btnArea,
      children: /*#__PURE__*/_jsx(ButtonLink, {
        href: routes.channelDetail(course === null || course === void 0 || (_course$channel = course.channel) === null || _course$channel === void 0 ? void 0 : _course$channel.id),
        fillColor: true,
        large: true,
        fontFixed: true,
        children: "\u3055\u3063\u305D\u304F\u8996\u8074\u53EF\u80FD\u4F5C\u54C1\u3092\u30C1\u30A7\u30C3\u30AF\u3059\u308B"
      })
    })]
  });
}